// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Switch":"GLGq405M","label":"QO8lVpzt","container":"yYgV7L9J","disabled":"LSu49Gv2"};